const teethWhitening = {
  hero: {
    title: "Professional Teeth Whitening",
    description:
      "Transform your smile with our advanced teeth whitening procedures. Our professional treatments can lighten your teeth by several shades in just one session, removing years of stains and discoloration.",
    ctas: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
    imageAlt: "Teeth Whitening Treatment",
    callout: {
      title: "Quick Treatments",
      body: "Most procedures take only 60-90 minutes",
    },
  },
  benefits: {
    heading: "BENEFITS OF TEETH WHITENING",
    intro:
      "Experience the many advantages of our professional teeth whitening services",
    items: [
      {
        title: "Enhanced Confidence",
        description:
          "A brighter smile can significantly boost your self-esteem and make you more confident in social and professional settings.",
      },
      {
        title: "Dramatic Results",
        description:
          "Our professional whitening treatments can lighten your teeth by several shades in just one session, providing immediate results.",
      },
      {
        title: "Quick Treatment",
        description:
          "Unlike home remedies that take weeks to show results, our in-office whitening procedures typically take only 60-90 minutes.",
      },
      {
        title: "Customized Solutions",
        description:
          "We tailor our whitening treatments to your unique needs and sensitivity level for optimal comfort and results.",
      },
      {
        title: "Safe & Professional",
        description:
          "Our treatments are performed by trained dental professionals using high-quality, clinically proven whitening agents.",
      },
      {
        title: "Youthful Appearance",
        description:
          "A bright, white smile can take years off your appearance, helping you look and feel younger and more vibrant.",
      },
    ],
  },
  process: {
    heading: "THE WHITENING PROCESS",
    intro:
      "Our teeth whitening process is designed to be safe, effective, and comfortable, providing outstanding results with minimal sensitivity",
    steps: [
      {
        title: "Initial Consultation",
        description:
          "We conduct a thorough examination of your teeth and discuss your whitening goals to create a personalized treatment plan.",
      },
      {
        title: "Teeth Preparation",
        description:
          "Your teeth are professionally cleaned to remove any surface stains and plaque before the whitening procedure.",
      },
      {
        title: "Whitening Application",
        description:
          "A professional-grade whitening gel is carefully applied to your teeth using custom-fitted trays for maximum effectiveness.",
      },
      {
        title: "Light Activation",
        description:
          "In some treatments, a special light is used to accelerate the whitening process by activating the ingredients in the gel.",
      },
      {
        title: "Final Results",
        description:
          "After the procedure, you'll see immediate results with teeth that are noticeably whiter and brighter.",
      },
      {
        title: "Aftercare Instructions",
        description:
          "We provide guidance on maintaining your new smile, including dietary recommendations and home care products.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro:
      "Get answers to common questions about our teeth whitening treatments",
    items: [
      {
        question: "How long does professional teeth whitening last?",
        answer:
          "The results of professional teeth whitening can last anywhere from 6 months to 2 years, depending on your lifestyle habits such as smoking, coffee consumption, and oral hygiene practices. Regular touch-ups can help maintain your bright smile for longer.",
      },
      {
        question: "Is teeth whitening safe?",
        answer:
          "Yes, when performed by dental professionals, teeth whitening is considered safe. We use clinically tested products and carefully assess your oral health before recommending any whitening treatment to ensure it's appropriate for you.",
      },
      {
        question: "Will teeth whitening cause sensitivity?",
        answer:
          "Some patients may experience temporary sensitivity after whitening treatments. However, we take precautions to minimize this by using desensitizing agents before and after treatment, and adjusting the concentration of whitening gel based on your specific needs.",
      },
      {
        question: "How white will my teeth get?",
        answer:
          "Results vary from person to person, but most patients see an improvement of 2-8 shades. The final outcome depends on your natural tooth color, the cause of discoloration, and how your teeth respond to the whitening agents.",
      },
      {
        question:
          "What's the difference between professional whitening and over-the-counter products?",
        answer:
          "Professional whitening uses higher-concentration whitening agents that are not available over the counter, resulting in faster and more dramatic results. Additionally, professional treatments are customized to your specific needs and supervised by dental experts for safety and effectiveness.",
      },
      {
        question: "How should I maintain my whitened teeth?",
        answer:
          "To maintain your results, we recommend good oral hygiene practices, limiting consumption of staining foods and beverages (coffee, red wine, tea), avoiding tobacco products, using a straw when drinking dark liquids, and scheduling periodic touch-up treatments as needed.",
      },
    ],
  },
};

export default teethWhitening;

